import state from '@/store/module_pesquisa/state'
import mutations from '@/store/module_pesquisa/mutations'
import actions from '@/store/module_pesquisa/actions'

export default ({
  state,
  mutations,
  actions,
})